import { render } from "./test.vue?vue&type=template&id=7136266c&ref=fullscreenElement"
import script from "./test.vue?vue&type=script&lang=ts"
export * from "./test.vue?vue&type=script&lang=ts"
script.render = render

export default script